// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvaPaisInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /localidades/salvaPais
 *
 * Creates or updates a country in the locations service.
 */
import { registerContract } from './validate'

export interface Localidades_SalvaPaisInput {
pais_nome: string
pais_id?: number
pais_sigla?: string
}

registerContract('Localidades_SalvaPaisInput', {
  pais_nome:  { type: 'string',  required: true },
  pais_id:    { type: 'number',  required: false },
  pais_sigla: { type: 'string',  required: false },
})
